import Head from "next/head";

export default function SEO({
  data: { title, description, indexing, og: og_meta, twitter: twitter_meta },
}) {
  const live = process.env.IS_LIVE;
  return (
    <Head>
      {/* Primary Meta Tags  */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <link
        href="https://storage.googleapis.com/answerforce-cms/icons/favicon-af.ico"
        rel="icon"
        sizes="16x16"
        type="image/x-icon"
      />
      <link
        href="https://storage.googleapis.com/answerforce-cms/icons/favicon-af-16x16.png"
        rel="icon"
        sizes="16x16"
        type="image/png"
      />
      <link
        href="https://storage.googleapis.com/answerforce-cms/icons/favicon-af-32x32.png"
        rel="icon"
        sizes="32x32"
        type="image/png"
      />
      <link
        href="https://storage.googleapis.com/answerforce-cms/icons/favicon-af-48x48.png"
        rel="icon"
        sizes="48x48"
        type="image/png"
      />
      <link
        href="https://storage.googleapis.com/answerforce-cms/icons/apple-touch-icon-af-180x180.png"
        rel="apple-touch-icon"
        sizes="180x180"
      />
      <meta name="apple-mobile-web-app-title" content="AnswerForce" />
      <link href="/site.webmanifest" rel="manifest" />

      {/* {indexing} */}
      {live ? (
        <>{!indexing && <meta name="robots" content="noindex, nofollow" />}</>
      ) : (
        <meta name="robots" content="noindex, nofollow" />
      )}

      {/* Open Graph / Facebook  */}
      {og_meta && (
        <>
          <meta property="og:title" content={og_meta.title} />
          <meta property="og:description" content={og_meta.description} />
          <meta property="og:url" content={og_meta.url} />
          <meta property="og:image" content={og_meta.image} />
          <meta property="og:type" content="website" />
        </>
      )}

      {/* Twitter  */}
      {twitter_meta && (
        <>
          <meta property="twitter:title" content={twitter_meta.title} />
          <meta
            property="twitter:description"
            content={twitter_meta.description}
          />
          <meta property="twitter:url" content={twitter_meta.url} />
          <meta property="twitter:image" content={twitter_meta.image} />
          <meta name="twitter:image:alt" content={twitter_meta.image_alt} />
          <meta property="twitter:card" content="summary_large_image" />
          <meta name="twitter:site" content="@answerforce" />
          <meta name="twitter:creator" content="@answerforce" />
        </>
      )}
      {/* {canonical slugs} */}
      {og_meta && (
        <>
          <link rel="canonical" href={og_meta.url} />
          <link rel="alternate" href={og_meta.url} hreflang="en-us" />
          <link rel="alternate" href={og_meta.url} hrefLang="x-default" />
          {og_meta.url_ca && (
            <link rel="alternate" href={og_meta.url_ca} hreflang="en-ca" />
          )}
        </>
      )}
    </Head>
  );
}
